var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4L9 9 4 4z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDkiPgogICAgPHBhdGggZD0iTTcsMTRsNS01LDUsNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxIDE4KSByb3RhdGUoMTgwKSIvPgo8L3N2Zz4=";
export { SvgCaretDown as ReactComponent };